export class Filter {
	constructor(loadMoreInstance = null) {
		this.filterButtons = document.querySelectorAll(".filter__button");
		this.cards = [...document.querySelectorAll(".card[data-categories]")];
		this.loadMore = loadMoreInstance;
		this.isReducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)"
		).matches;

		if (!this.filterButtons.length || !this.cards.length) return;

		this.init();
		this.handleInitialFilter();
	}

	init() {
		this.filterButtons.forEach((button) => {
			button.addEventListener("click", (e) => {
				e.preventDefault();
				const filterValue = button.dataset.filter;

				// Update URL hash
				this.updateURL(filterValue);

				// Update active state
				this.updateActiveButton(button);

				// Apply filter with view transition if supported and motion is not reduced
				if (document.startViewTransition && !this.isReducedMotion) {
					// Add view transition name and class to cards before transition
					this.cards.forEach((card, index) => {
						card.style.viewTransitionName = `card-${index}`;
						card.style.viewTransitionClass = 'card';
					});

					const transition = document.startViewTransition(() => {
						this.filterCards(filterValue);
						// Notify load more about filter change
						if (this.loadMore) {
							this.loadMore.onFilterChange();
						}
					});

					// Clean up transition name and class after transition
					transition.finished.then(() => {
						this.cards.forEach(card => {
							card.style.viewTransitionName = '';
							card.style.viewTransitionClass = '';
						});
					}).catch(() => {
						// Clean up on error too
						this.cards.forEach(card => {
							card.style.viewTransitionName = '';
							card.style.viewTransitionClass = '';
						});
					});
				} else {
					this.filterCards(filterValue);
					// Notify load more about filter change
					if (this.loadMore) {
						this.loadMore.onFilterChange();
					}
				}
			});
		});
	}

	handleInitialFilter() {
		const hash = window.location.hash.slice(1);
		if (hash) {
			// Decode URL hash (e.g., "Weitere%20Formate" → "Weitere Formate")
			const decodedHash = decodeURIComponent(hash);
			const button = this.findButtonByFilter(decodedHash);
			if (button) {
				this.updateActiveButton(button);
				this.filterCards(decodedHash);
				// Notify load more about initial filter
				if (this.loadMore) {
					this.loadMore.onFilterChange();
				}
			}
		}
	}

	findButtonByFilter(filterValue) {
		return Array.from(this.filterButtons).find(
			(button) => button.dataset.filter === filterValue
		);
	}

	updateURL(filterValue) {
		if (filterValue === "all") {
			// Remove hash completely
			const url = window.location.pathname + window.location.search;
			window.history.replaceState(null, "", url);
		} else {
			// Add hash without encoding
			window.history.replaceState(null, "", `#${filterValue}`);
		}
	}

	updateActiveButton(activeButton) {
		// Remove active class from all buttons
		this.filterButtons.forEach((button) => {
			button.classList.remove("filter__button--active");
			button.setAttribute("aria-pressed", "false");
		});

		// Add active class to clicked button
		activeButton.classList.add("filter__button--active");
		activeButton.setAttribute("aria-pressed", "true");
	}

	filterCards(filterValue) {
		this.cards.forEach((card) => {
			if (filterValue === "all") {
				// Show all cards
				card.classList.remove("card--hidden");
			} else {
				// Check if card has the filter category
				const cardCategories = card.dataset.categories || "";
				const hasCategory = cardCategories
					.split(";")
					.some((cat) => cat.trim() === filterValue);

				if (hasCategory) {
					card.classList.remove("card--hidden");
				} else {
					card.classList.add("card--hidden");
				}
			}
		});
	}
}
